export default __webpack_public_path__ + "static/media/images.cd678315.jpeg";